import { createBrowserRouter } from "react-router-dom";
import LandingPage from "./Pages/LandingPage";
import DetailPage from "./Pages/DetailPage";
import RootLayout from "./Util/RootLayout";

const router = createBrowserRouter([
  {
    element: <RootLayout />, // Semua halaman dibungkus RootLayout
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/DetailPage/:id",
        element: <DetailPage />,
      },
    ],
  },
]);

export default router;
